'use client';
var classes = {"root":"m_7341320d"};

export { classes as default };
//# sourceMappingURL=ThemeIcon.module.css.mjs.map
